// @flow

import React from 'react';

import { Document } from '@zapier/common-components';

import ZapMoverContainer from 'app/zap-mover/components/ZapMoverContainer';
import ZapMoverStatusContainer from 'app/zap-mover/components/ZapMoverStatusContainer';

type Props = {
  fromAccountId?: number,
  isMoving: boolean,
  toAccountId?: number,
};

const App = (props: Props) => {
  const Component = props.isMoving
    ? ZapMoverStatusContainer
    : ZapMoverContainer;
  return (
    <Document title="Move Zaps Between Accounts">
      <Component
        fromAccountId={props.fromAccountId}
        toAccountId={props.toAccountId}
      />
    </Document>
  );
};

export default App;
